import React from 'react'
import InfoFieldGroup from '../../../utils/InfoField/InfoFieldGroup'
import Header from './header'
import ButtonSwitch from './buttonSwitch'

export default function ControloQualidadePrivilegios({ user, permissions, setPermissions }) {
  return (
    <>

{/* 


controleQualidadeEmissaoCertificado
controleQualidadeChefeDepartamento
controleQualidadeDirectorGeralAdjunta */}

      <Header header={'Controlo de Qualidade'} />
      <InfoFieldGroup
        fields={
          [
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'controleQualidadeAnalise'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Controlo de Qualidade em Análise '}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'controleQualidadeAtribuirAnalistaRevisor'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Controlo de Qualidade Atribuir Analista e Revisor'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'controleQualidadeRelatorioAnalitico'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Controlo de Qualidade Atribuir Emitir Relatório Análitico'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'controleQualidadeEmissaoCertificado'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Controlo de Qualidade Emissão do Certificado'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'controleQualidadeChefeDepartamento'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Controlo de Qualidade em Chefe de Departamento'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'controleQualidadeDirectorGeralAdjunta'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Controlo de Qualidade em Directora Geral Adjunta'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'controleQualidadeDirectorGeral'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Controlo de Qualidade em Director Geral'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'reclamacoesControloQualidade'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Gestão de Reclamações do Controlo de Qualidade'}
                  descricao={''}
                />
              , editable: false,
            },
          ]} />

    </>
  )
}
